import {
  ChangeDetectionStrategy,
  Component,
  computed,
  HostListener,
  inject,
  Input,
  signal,
  WritableSignal,
} from '@angular/core';
import { Ln360SvgIconComponent } from '../svg-icons/ln-360-svg-icon/ln-360-svg-icon.component';
import { LnRealidadVirtualSvgIconComponent } from '../svg-icons/ln-realidad-virtual-svg-icon/ln-realidad-virtual-svg-icon.component';
import { LnRealidadAumentadaSvgIconComponent } from '../svg-icons/ln-realidad-aumentada-svg-icon/ln-realidad-aumentada-svg-icon.component';
import { LnShareSvgIconComponent } from '../svg-icons/ln-share-svg-icon/ln-share-svg-icon.component';
import { LnProductInfoDetailShareBarComponent } from '../ln-product-info-detail-share-bar/ln-product-info-detail-share-bar.component';
import { LnPrimaryButtonComponent } from '@components/butons/ln-primary-button/ln-primary-button.component';
import { InfoBgBeigeSvgIconComponent } from '@components/svg-icons/info-bg-beige-svg-icon/info-bg-beige-svg-icon.component';
import { ProductDetails } from '@interfaces/products/product_detail_interface';
import { PriceFormatPipe } from '../../pipes/price-format.pipe';
import { DropdownComponent } from '@components/dropdown/dropdown.component';
import { ShoppingCartState } from '../../states/shopping-cart-state';
import { ShoppingCartAddItemInterface } from '@interfaces/shopping-cart/shopping-cart-add-item-interface';
import { MenuActions } from '../../states/menu_actions';
import { interval } from 'rxjs';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'ln-product-info-detail',
  imports: [
    Ln360SvgIconComponent,
    LnRealidadVirtualSvgIconComponent,
    LnRealidadAumentadaSvgIconComponent,
    LnPrimaryButtonComponent,
    LnShareSvgIconComponent,
    LnProductInfoDetailShareBarComponent,
    InfoBgBeigeSvgIconComponent,
    PriceFormatPipe,
    DropdownComponent,
    TranslocoPipe,
  ],
  templateUrl: './ln-product-info-detail.component.html',
  styleUrl: './ln-product-info-detail.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnProductInfoDetailComponent {
  // private readonly TAG = 'LnProductInfoDetailComponent';
  @Input({ required: true }) productDetails!: ProductDetails;
  @Input({ required: true }) selectedVariant!: WritableSignal<number>;
  protected showButonSpinner: WritableSignal<boolean> = signal(false);
  protected primaryButonText: WritableSignal<string> = signal('Agregar al carrito');
  private shoppingCartState = inject(ShoppingCartState);
  private menuActions = inject(MenuActions);
  protected showShareBar: WritableSignal<boolean> = signal(false);
  protected isDesktop: WritableSignal<boolean> = signal(window.innerWidth >= 640); // Tailwind sm breakpoint
  readonly piezaUnica = computed(() => this.productDetails.isPiezaUnica);
  private updatingPrimaryButonText = false;

  toggleShareBar() {
    // Only toggle if it's not desktop (mobile)
    if (!this.isDesktop()) {
      this.showShareBar.set(!this.showShareBar);
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isDesktop.set(window.innerWidth >= 640);
    if (this.isDesktop()) {
      this.showShareBar.set(false);
    }
  }

  agregarAlCarritoClicket() {
    if (!this.updatingPrimaryButonText) {
      this.showButonSpinner.set(true);
      const shoppingCartProduct: ShoppingCartAddItemInterface = {
        productId: this.productDetails!.productos[this.selectedVariant()].id,
        amount: 1,
      };
      this.shoppingCartState.addToCart(shoppingCartProduct).subscribe(() => {
        this.showButonSpinner.set(false);
        this.changePrimaryButonText();
      });
    }
  }
  vide360Clicked() {
    if (this.productDetails.video360Url != null) {
      this.menuActions.navigateToURL(this.productDetails.video360Url);
    }
  }
  realidadVirtualClicked() {
    if (this.productDetails.vrUrl != null) {
      this.menuActions.navigateToURL(this.productDetails.vrUrl);
    }
  }
  realidadAumentadaClicked() {
    if (this.productDetails.arUrl != null) {
      this.menuActions.navigateToURL(this.productDetails.arUrl);
    }
  }

  guiaDeTallasClicked() {
    if (this.productDetails.vendedor.pdfInfoAtributo != null) {
      this.menuActions.navigateToURL(this.productDetails.vendedor.pdfInfoAtributo);
    }
  }

  changePrimaryButonText() {
    this.updatingPrimaryButonText = true;
    this.primaryButonText.set('Producto agregado al carrito');
    const timerSubscription = interval(1000).subscribe(() => {
      this.primaryButonText.set('Agregar al carrito');
      this.updatingPrimaryButonText = false;
      timerSubscription.unsubscribe();
    });
  }

  navigateToArtisanProfile() {
    const sellerID = this.productDetails.vendedor.id;
    if (sellerID.length) {
      this.menuActions.navigateToArtisanProfile(sellerID);
    }
  }
}
